import { useTikTokAdvertiserSummaryData } from '@anytag/shared-organisms';
import { TikTokCampaigns } from '../../../pages/tiktok-advertiser-pages';

export const TikTokCampaignsComponent = () => {
  const { summaryData } = useTikTokAdvertiserSummaryData();

  return <TikTokCampaigns summaryData={summaryData} />;
};
